export default "__VITE_ASSET__CbxbrNT3__"